import { categoryLabel } from './forum-options.ts'

export type ForumSearchTopic = {
  title: string
  body: string
  category: string
  tags: string[]
  author_handle: string
  replies: Array<{
    body: string
    author_handle: string
  }>
}

export function matchingForumReply(topic: ForumSearchTopic, query: string) {
  const needle = query.trim().toLowerCase()
  if (!needle) return null
  return (
    topic.replies.find(
      (reply) =>
        reply.author_handle.toLowerCase().includes(needle) ||
        reply.body.toLowerCase().includes(needle),
    ) ?? null
  )
}

export function forumTopicMatchesSearch(topic: ForumSearchTopic, query: string) {
  const needle = query.trim().toLowerCase()
  if (!needle) return true
  return (
    topic.title.toLowerCase().includes(needle) ||
    topic.body.toLowerCase().includes(needle) ||
    topic.author_handle.toLowerCase().includes(needle) ||
    topic.tags.some((tag) => tag.toLowerCase().includes(needle)) ||
    categoryLabel(topic.category).toLowerCase().includes(needle) ||
    matchingForumReply(topic, needle) !== null
  )
}

export function matchingForumReplyExcerpt(body: string, query: string) {
  const needle = query.trim().toLowerCase()
  const text = body.replace(/\s+/g, ' ').trim()
  const matchIndex = text.toLowerCase().indexOf(needle)
  if (matchIndex < 0 || text.length <= 180) return text
  const start = Math.max(0, matchIndex - 60)
  const end = Math.min(text.length, start + 180)
  return `${start > 0 ? '…' : ''}${text.slice(start, end)}${end < text.length ? '…' : ''}`
}
